<script setup lang="ts">
import { UiText } from '@shopexperts/shared';

defineProps<{
  label: string;
  value?: string | null;
  /** Span the whole row, for bios and other long content. */
  wide?: boolean;
}>();
</script>

<template>
  <div class="min-w-0" :class="{ 'col-span-full': wide }">
    <dt class="mb-0.5">
      <UiText as="span" variant="caption-normal" class="text-gray-400" :text="label" />
    </dt>
    <dd class="min-w-0">
      <slot>
        <UiText v-if="value" as="span" variant="p-small" class="text-gray-700 break-words" :text="value" />
        <UiText v-else as="span" variant="p-small" class="text-gray-300" text="—" />
      </slot>
    </dd>
  </div>
</template>
